export default "__VITE_ASSET__f5U6QiUo__"